
import { useState, useRef } from "react";
import Config from "../Config";
import InputComboGrupa from "./InputComboGrupa";
import InputTextAlpha from "./InputTextAlpha";
import InputComboStawkiWyzMulti from "./InputComboStawkiWyzMulti";
import InputCombo from "./InputCombo";




function InputParentsMulti(props)
{

    const [filterParam, setFilterParam] = useState({
        imie: props.mainView.readFilter('imie',''), 
        nazwisko:  props.mainView.readFilter('nazwisko',''),  
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

        zawiera_stawke: '',
        niezawiera_stawki: '',

        stan_umowy: '1',
    });


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    var clFlag = 1;
    if(props.clearFlag != null && props.clFlag != undefined) clFlag = props.clFlag;
    var [clearFlag, setClearFlag] = useState(clFlag);


    var max = 1000;
    if(props.max != undefined && props.max != null) max = props.max;

    const [maxKids,setMaxKids] = useState(max);

    const [tabSelected, setTabSelected] = useState([
       
    ]);


    const [view, setView] = useState('btn');


    const getTab = () => {
            
        
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_calc,kids', {
            method: 'POST', 
            body: '', 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {                                              
                        setTab(res.result);                                         
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn'); 
    } 


    const saveData = () => {


        var selected = new Array();

        var selectedCallback = new Array();

        for(var g=0; g < tab.length; g++)
            {                
                    for(var d=0; d < tab[g].dzieci.length; d++)
                        {
                                
                              if(tab[g].dzieci[d].param1 == '1')  {  

                                selected.push( tab[g].dzieci[d]);
                          
                                    for(var r=0; r < tab[g].dzieci[d].rodzice.length; r++   )
                                    {
                                        

                                        selectedCallback.push( {
                                            px_group_id: tab[g].dzieci[d].rodzice[r].id,
                                            imie: tab[g].dzieci[d].rodzice[r].imie,
                                            nazwisko: tab[g].dzieci[d].rodzice[r].nazwisko,
                                            p_dziecko_id: tab[g].dzieci[d].id
                                          } );                                        
                                    }

                              };
                               
                        }   
                
            }

            setTabSelected(selected);
            changeView();

            if(props.onParentsSelected != undefined) props.onParentsSelected(selectedCallback);

    }


    const goSelect = (e) => {

        var p_grupa_id = e.currentTarget.getAttribute('p_grupa_id');
        var p_dziecko_id = e.currentTarget.getAttribute('p_dziecko_id');

        //console.log(p_grupa_id, p_dziecko_id);

        for(var g=0; g < tab.length; g++)
        {
            if(tab[g].id == p_grupa_id )
            {
                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                            if(tab[g].dzieci[d].id == p_dziecko_id )
                            {
                                if(tab[g].dzieci[d].param1 == '0')  {  tab[g].dzieci[d].param1 = '1' } else tab[g].dzieci[d].param1 = '0' ;
                            }else
                            {
                                if(maxKids == 1)    tab[g].dzieci[d].param1 = '0' ;
                            }
                    }   
            }else 
            if(maxKids == 1) {

                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                         tab[g].dzieci[d].param1 = '0' ;
                    } 
            }


        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));

    }


    const selectAll = (e) =>  {


        if(maxKids == 1) return;

        var p_grupa_id = e.target.getAttribute('id');
        var txt        = e.target.innerHTML;

     
        if(txt == 'zaznacz')
        {
            e.target.innerHTML = 'odznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {

                                    var canSelect1 = false; //czy spelnia filtry i można zaznaczyć dziecko.
                                    var canSelect2 = false; //czy spelnia filtry i można zaznaczyć dziecko.
                                    var canSelect3 = false; //czy spelnia filtry i można zaznaczyć dziecko.

                                    var isAnyContract  = false;
                                    var isAnyContractActive  = false;
                                    var isAnyContractClose   = false;
                                    var isAnyContractWaiting  = false;

                                    if( tab[g].dzieci[d].umowy != undefined )
                                    {
                                        for(var uu=0; uu < tab[g].dzieci[d].umowy.length; uu++ )
                                        {
                                            isAnyContract = true;
                                            if(tab[g].dzieci[d].umowy[uu].stan_umowy == '1' )  isAnyContractActive = true;                                              
                                            if(tab[g].dzieci[d].umowy[uu].stan_umowy == '2' )  isAnyContractClose = true;                                              
                                            if(tab[g].dzieci[d].umowy[uu].stan_umowy == '3' )  isAnyContractWaiting = true;                                              
                                        }
                                    }

                                    if(filterParam.stan_umowy == '1'  && isAnyContractActive )
                                    {
                                            canSelect1 = true;
                                    }else
                                    if(filterParam.stan_umowy == '2'  && isAnyContractClose )
                                    {
                                            canSelect1 = true;
                                    }else
                                    if(filterParam.stan_umowy == '3'  && isAnyContractWaiting )
                                    {
                                            canSelect1 = true;
                                    }else
                                    if(filterParam.stan_umowy == '_x_')
                                    {
                                            canSelect1 = true;
                                    }else
                                    if(filterParam.stan_umowy == '_y_' && isAnyContract == false)
                                    {
                                            canSelect1 = true;
                                    }

                                    //-------------------------------------------------------------


                                    if(filterParam.imie.length < 1)
                                    {
                                        canSelect2 = true;
                                    }else 
                                    {
                                        canSelect2 = false;
                                        if(tab[g].dzieci[d].imie.toLowerCase().includes(  filterParam.imie.toLowerCase()  ) ) canSelect2 = true;
                                    }

                                    //----------------------------------------------------------------
 

                                    if(filterParam.nazwisko.length < 1)
                                    {
                                        canSelect3 = true;
                                    }else 
                                    {
                                        canSelect3 = false;
                                        if(tab[g].dzieci[d].nazwisko.toLowerCase().includes(  filterParam.nazwisko.toLowerCase()  ) ) canSelect3 = true;
                                    }

                                    //----------------------------------------------------------------



                                    if(canSelect1 && canSelect2 && canSelect3)
                                    {
                                          tab[g].dzieci[d].param1 = '1';
                                    }

                                        
                                   
                            }   
                    }
                }

        }else
        {
            e.target.innerHTML = 'zaznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                    
                                tab[g].dzieci[d].param1 = '0';
                                
                            }   
                    }
                }
        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));
        
    }


    
 


    const valChangeListener = (filedName, val, correct, msg) => {

       //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );               
    }


    const goNextNew = () => {
        console.log("goNext");               
    }


    var itemsStanyUmowy = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '_y_',
            title: 'Nie ma żadnej umowy'
        },
        {
            v: '1',
            title: 'Umowa zawarta, generuj rozliczenia'
        },
        {
            v: '2',
            title: 'Umowa rozwiązana/zakończona'
        },
        {
            v: '3',
            title: 'Umowa czeka na podpis'
        },
    ];


    


    
    if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }


        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
            setTabSelected([]);
        }


        if(props.clearFlag != null && props.clearFlag != undefined)
        {
            if(props.clearFlag != clearFlag)
            {
                setClearFlag(props.clearFlag);
                setTab(null);           
                setTabSelected([]);
            }
        }


        var dlg_view = null;

     if(view != 'btn') 
     {

        //-----------------------------------------------------------

        console.log(filterParam);

        var rTab = new Array();


        for(var k=0; k<tab.length; k++) //petla po grupach..
        {
         

            var nDz = new Array();

            for(var d = 0; d < tab[k].dzieci.length; d++  )
            {
                var goAdd0 = true;
                var goAdd1 = true;
                var goAdd2 = true;
                var goAdd3 = true;
                var goAdd4 = true;
                var goAdd5 = true;


                var dz = tab[k].dzieci[d];


                if(filterParam.p_grupa_id != "_x_")
                {
                    goAdd0 = false;

                    if(tab[k].id == filterParam.p_grupa_id) goAdd0 = true;
                }


                if(filterParam.imie.length > 2)
                {
                    goAdd1 = false;

                    if(  dz.imie.toLowerCase().includes( filterParam.imie.toLowerCase() )  )
                    {
                            goAdd1 = true;
                    }
                }

                if(filterParam.nazwisko.length > 2)
                {
                        goAdd2 = false;
    
                        if(  dz.nazwisko.toLowerCase().includes( filterParam.nazwisko.toLowerCase() )  )
                        {
                                goAdd2 = true;
                        }
    
                }

                if(filterParam.zawiera_stawke != "")
                {
                        goAdd3 = false;

                        if(dz.umowy.length == 0) { 
                            goAdd3 = false; // nie zawiera stawki.. bo nie ma umowy..
                        }else
                        {                            
                           
                            for(var uI=0; uI < dz.umowy.length; uI++)
                            {
                                    var umAll = true; //czy zawiera wszystnie niezbedne stawki...? domyslnie tak..
                                    var ids = filterParam.zawiera_stawke.split(",");

                                    for(var it = 0; it < ids.length; it++)
                                    {
                                        var isIn = false;

                                            for(var st=0; st < dz.umowy[uI].stawki.length; st ++)
                                            {                                        
                                                if( dz.umowy[uI].stawki[st].id == ids[it] )
                                                {                                          
                                                        isIn = true;
                                                }
                                            }

                                            if(!isIn) umAll = false;
                                    } 

                                    if(umAll){
                                        //ta umowa zawiera wszystkie niezbedne stawki..
                                        goAdd3 = 3;
                                    }
                            }                                        
                                                   

                        }                         
                }


                if(filterParam.niezawiera_stawki != "")
                {
                   
                        goAdd4 = false;

                        if(dz.umowy.length  == 0 ) { 
                            goAdd4 = true; //nie ma umowy, nie zawiera zadnej stawki..
                        }else
                        {

                        
                           var umAll = false; //czy zawiera min jedna stawke..
                           goAdd4 = true;

                            for(var uI=0; uI < dz.umowy.length; uI++)
                                {
                                       
                                        var ids = filterParam.niezawiera_stawki.split(",");
    
                                        for(var it = 0; it < ids.length; it++)
                                        {
                                            var isIn = false;
    
                                                for(var st=0; st < dz.umowy[uI].stawki.length; st ++)
                                                {                                        
                                                    if( dz.umowy[uI].stawki[st].id == ids[it] )
                                                    {                                          
                                                        umAll = true;
                                                        console.log("XXX " ,dz.imie, dz.nazwisko, dz.umowy[uI].stawki[st].id,  ids[it] );
                                                    }
                                                }
     
                                        }                                             
                                }
                                
                            if(umAll){                                            
                                    goAdd4 = false;
                                }


                        }
                            
                }


                if(filterParam.stan_umowy != '_x_')
                {
                        goAdd5 = false;

                        if(filterParam.stan_umowy == '_y_')
                        {
                            if(dz.umowy.length == 0) goAdd5 = true;
                        }
                        

                        for(var uI=0; uI < dz.umowy.length; uI++)
                            {
                                  if(dz.umowy[uI].stan_umowy == filterParam.stan_umowy  ) 
                                  {
                                        goAdd5 = true;
                                  }
                            }


                }


                if( goAdd0 && goAdd1 && goAdd2 && goAdd3 && goAdd4 && goAdd5)
                {
                    nDz.push( tab[k].dzieci[d] );
                }
            }


            if(nDz.length > 0)
            {
                var rRow        = new Array();
                rRow["id"]      = tab[k].id;
                rRow["nazwa"]   = tab[k].nazwa;
                rRow["dzieci"]  = nDz;
    
                rTab.push(rRow);
            }
                       

        }

        //-----------------------------------------------------------




        var dlg_view =  (

            <div className="dlg_window dlg_type_xxx shadowx">
    
                    <div className="dlg_title">
                         Wybierz dzieci - rodziców
                    </div>
    



                    <div className="table_filter">
                      

                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 


                            <div className="filter_controll">   
                                        <label>Imię dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div> 

                            <br/>


                            <div className="filter_controll">   
                                <label>Stan umowy: </label>                             
                                <InputCombo  items={itemsStanyUmowy}  userData={props.userData}  mainView={props.mainView}  value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy"    />
                            </div> 


                            <div className="filter_controll">   
                                <label>MA przypisane wszystkie stawki: </label>                             
                                <InputComboStawkiWyzMulti  value={filterParam.zawiera_stawke}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="zawiera_stawke"    />
                            </div> 


                            <div className="filter_controll">   
                                <label>NIE MA przypisanej żadnej stawki: </label>                             
                                <InputComboStawkiWyzMulti  value={filterParam.niezawiera_stawki}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="niezawiera_stawki"    />
                            </div> 


                    </div>
    




                    <div className="dlg_content_x">
    
    
                                      <div className="xselect_multi xparents">
                                        {
                                            rTab.map( (gr, gi) => {
                                                return <div className="row_gr" >


                                                     {
                                                          maxKids != 1 &&
                                                         <strong>{gr.nazwa} <sup className="link_color"  id={gr.id} onClick={selectAll}>zaznacz</sup>   </strong>
                                                     }
                                                     
                                                     
                                                     <ul>
                                                            {
                                                                gr.dzieci.map( (dz, di) => {

                                                                   
                                                                        if(dz.rodzice.length == 0)
                                                                        {
                                                                            return null;
                                                                        }

                                                                        var css = '';

                                                                        if(dz.param1 == '1') css ="selected";

                                                                        return <li className={css}    p_grupa_id={gr.id} p_dziecko_id={dz.id} onClick={goSelect} >  
                                                                                    <div className="xselect_item">

                                                                                    <div className="xselect_t_title"   >{ dz.nazwisko + " " + dz.imie    } </div>
                                                                                    <div className="xselect_t_content">
                                                                                    {
                                                                                            dz.rodzice.map( (rdz, inx) => {
                                                                                                return <div    > {rdz.nazwisko + " " + rdz.imie} </div>
                                                                                            } )
                                                                                    }
                                                                                    </div>

                                                                                    </div>                                                                                                                                                     
                                                                                
                                                                            </li>
                                                                } ) 

                                                            }
                                                     </ul>
                                                     
                                                </div>
                                            } )
                                        }
                                      </div>  
    
                                        <br/>    
                                        <br/>   
    
                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>
    
                    </div>
    
                
            </div>
    );

    }
   
    
    var info = '';
    var ilosc = null;


    if(tabSelected.length == 0)
    {
        info = <div onClick={changeView} className="link_bad">Nie wybrano żadnego odbiorcy</div>; ;
    }else
    {
            ilosc = <div>
                <strong>wybranych: {tabSelected.length}</strong>
            </div>
    }
    
    return  <div>

                <br/>
                <div className="btn"    onClick={changeView} >wybierz odbiorców / lista rodziców</div> 

                <div className="xselect xparents">
                    {ilosc}
                    <br/>
                        {
                            tabSelected.map( (r, ix) => {
                                return <div className="xselect_item" onClick={changeView}>
                                           <div className="xselect_t_title">{r.nazwisko} {r.imie}  </div>
                                           <div className="xselect_t_content">
                                               {
                                                 r.rodzice.map(  (rr, ir) => {
                                                    return <div> {rr.imie + " " + rr.nazwisko}  </div>
                                                 } )
                                               }
                                           </div>
                                    </div>
                            } )
                        }

                        {info}

                        <br/>
                </div>


                {dlg_view} 
           </div>
}



export default InputParentsMulti;